export const UNNAMED_CHANNEL_GROUP_KEY = '__unnamed_channel_group__';
export const UNNAMED_CHANNEL_GROUP_LABEL = '未命名';

export function normalizeChannelGroupName(name) {
  const normalizedName = typeof name === 'string' ? name.trim() : '';

  return {
    key: normalizedName || UNNAMED_CHANNEL_GROUP_KEY,
    name: normalizedName || UNNAMED_CHANNEL_GROUP_LABEL,
    isUnnamed: normalizedName.length === 0,
  };
}

export function getChannelReportGroupNames(channels) {
  const names = new Set();

  (channels || []).forEach((channel) => {
    const rawName = typeof channel.name === 'string' ? channel.name : '';
    names.add(rawName || UNNAMED_CHANNEL_GROUP_LABEL);
  });

  return Array.from(names);
}

export function mergeChannelReports(reportGroups) {
  const reports = new Map();

  (reportGroups || []).flat().forEach((report) => {
    const key = report.id
      ? `id:${report.id}`
      : [
          report.batch_id,
          report.channel_id,
          report.model_name,
          report.tested_at,
        ].join(':');
    if (!reports.has(key)) reports.set(key, report);
  });

  return Array.from(reports.values());
}

export function collectChannelModels(channels) {
  const models = new Set();

  (channels || []).forEach((channel) => {
    const channelModels = Array.isArray(channel.models)
      ? channel.models
      : typeof channel.models === 'string'
      ? channel.models.split(',')
      : [];

    channelModels.forEach((model) => {
      const normalizedModel = typeof model === 'string' ? model.trim() : '';
      if (normalizedModel) models.add(normalizedModel);
    });
  });

  return Array.from(models);
}

export function groupChannelsByName(channels) {
  const groups = new Map();

  (channels || []).forEach((channel) => {
    const normalized = normalizeChannelGroupName(channel.name);
    if (!groups.has(normalized.key)) {
      groups.set(normalized.key, {
        ...normalized,
        channels: [],
        enabledCount: 0,
        lastSuccessTime: 0,
      });
    }

    const group = groups.get(normalized.key);
    group.channels.push(channel);
    group.lastSuccessTime = Math.max(
      group.lastSuccessTime,
      Number(channel.last_success_time) || 0
    );
    if (channel.status === 1) group.enabledCount += 1;
  });

  const groupedChannels = Array.from(groups.values());
  groupedChannels.forEach((group) => {
    group.channels.sort((a, b) => {
      const timeDifference =
        (Number(b.last_success_time) || 0) - (Number(a.last_success_time) || 0);
      if (timeDifference !== 0) return timeDifference;
      return (Number(b.id) || 0) - (Number(a.id) || 0);
    });
  });

  const getStatusRank = (group) => {
    if (group.enabledCount === group.channels.length) return 0;
    if (group.enabledCount > 0) return 1;
    return 2;
  };

  groupedChannels.sort((a, b) => {
    if (a.isUnnamed !== b.isUnnamed) return a.isUnnamed ? 1 : -1;

    const statusDifference = getStatusRank(a) - getStatusRank(b);
    if (statusDifference !== 0) return statusDifference;

    const timeDifference = b.lastSuccessTime - a.lastSuccessTime;
    if (timeDifference !== 0) return timeDifference;

    return a.name.localeCompare(b.name, 'zh');
  });

  return groupedChannels;
}
